<template>
  <div class="academia-online">
    <!-- Top bar -->
    <div class="top-bar">
      <div class="container">
        <div class="top-links">
          <span>🎓 Más de 50,000 estudiantes</span>
          <span>⭐ 4.8 calificación promedio</span>
          <span>📞 +51 928 180 748</span>
        </div>
      </div>
    </div>

    <!-- Header -->
    <div class="main-header">
      <div class="container">
        <div class="header-row">
          <div class="logo" @click="goBack">
            <span class="logo-icon">🎓</span>
            <span class="logo-text">Academia<span class="logo-blue">Online</span></span>
          </div>
          <div class="search-wrapper">
            <div class="search-box">
              <input
                type="text"
                v-model="searchTerm"
                @keyup.enter="buscarCursos"
                placeholder="¿Qué quieres aprender hoy? (Ej: Python, Marketing, Diseño...)"
                class="search-input"
              />
              <button class="search-btn" @click="buscarCursos">🔍 Buscar</button>
            </div>
          </div>
          <div class="cart-floating-small" @click="verCarrito">
            <span>🛒</span>
            <span class="cart-count-small">{{ carrito.length }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Hero Banner -->
    <div class="hero-banner">
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <h1>Aprende sin límites</h1>
            <p>Accede a +300 cursos online con certificación internacional</p>
            <div class="hero-stats">
              <div class="stat">🎓 50,000+ estudiantes</div>
              <div class="stat">📚 300+ cursos</div>
              <div class="stat">⭐ 4.8 calificación</div>
            </div>
            <div class="hero-buttons">
              <button class="btn-primary" @click="scrollToCursos">
                Explorar cursos →
              </button>
              <button class="btn-secondary">📖 Ver plan de estudios</button>
            </div>
          </div>
          <div class="hero-image">🎓📚💻</div>
        </div>
      </div>
    </div>

    <!-- Promo banner -->
    <div class="promo-banner">
      <div class="container">
        <div class="promo-content">
          <span>🎁 ¡Lleva 3 cursos y obtén 50% OFF en el cuarto!</span>
          <span class="promo-code">Código: APRENDE50</span>
        </div>
      </div>
    </div>

    <!-- Categorías -->
    <div class="categories-section">
      <div class="container">
        <div class="section-title">
          <h2>📚 Explora por categoría</h2>
          <p>Encuentra el curso perfecto para ti</p>
        </div>
        <div class="categories-grid">
          <div
            v-for="cat in categorias"
            :key="cat.nombre"
            class="cat-card"
            @click="filtrarPorCategoria(cat.nombre)"
          >
            <div class="cat-icon">{{ cat.icono }}</div>
            <h3>{{ cat.nombre }}</h3>
            <p>{{ cat.cantidad }} cursos</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Cursos destacados -->
    <div id="cursos" class="courses-section">
      <div class="container">
        <div class="section-header">
          <h2>🔥 Cursos más populares</h2>
          <div class="filters">
            <button
              v-for="filtro in filtros"
              :key="filtro"
              :class="{ active: filtroActivo === filtro }"
              @click="filtroActivo = filtro"
            >
              {{ filtro }}
            </button>
          </div>
        </div>

        <div v-if="cursosFiltrados.length === 0" class="no-results">
          <p>No encontramos cursos para "{{ searchTerm }}"</p>
          <button @click="limpiarBusqueda">Limpiar búsqueda</button>
        </div>

        <div class="courses-grid">
          <div v-for="curso in cursosFiltrados" :key="curso.id" class="course-card">
            <div v-if="curso.oferta" class="course-badge">
              🔥 {{ curso.descuento }}% OFF
            </div>
            <div class="course-img">{{ curso.icono }}</div>
            <div class="course-info">
              <h3>{{ curso.nombre }}</h3>
              <p class="course-desc">{{ curso.descripcion }}</p>
              <div class="course-meta">
                <span>👨‍🏫 {{ curso.instructor }}</span>
                <span>⏱️ {{ curso.duracion }}</span>
                <span>📹 {{ curso.clases }} clases</span>
              </div>
              <div class="course-rating">
                ⭐ {{ curso.rating }} ({{ curso.reviews }} reseñas)
              </div>
              <div class="course-price">
                <span class="current">S/ {{ curso.precio }}</span>
                <span v-if="curso.precio_anterior" class="old"
                  >S/ {{ curso.precio_anterior }}</span
                >
              </div>
              <button class="add-btn" @click="agregarAlCarrito(curso)">
                🛒 Agregar al carrito
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Beneficios -->
    <div class="benefits-section">
      <div class="container">
        <div class="section-title">
          <h2>✨ ¿Por qué elegirnos?</h2>
        </div>
        <div class="benefits-grid">
          <div class="benefit">
            <div>🎓</div>
            <h4>Certificación oficial</h4>
            <p>Avalada por instituciones educativas</p>
          </div>
          <div class="benefit">
            <div>📹</div>
            <h4>Clases en vivo y grabadas</h4>
            <p>Acceso 24/7 a todo el contenido</p>
          </div>
          <div class="benefit">
            <div>👥</div>
            <h4>Comunidad activa</h4>
            <p>Foros y grupos de estudio</p>
          </div>
          <div class="benefit">
            <div>💼</div>
            <h4>Bolsa de trabajo</h4>
            <p>Acceso a ofertas exclusivas</p>
          </div>
          <div class="benefit">
            <div>📱</div>
            <h4>App móvil</h4>
            <p>Aprende desde tu celular</p>
          </div>
          <div class="benefit">
            <div>🔄</div>
            <h4>Garantía 30 días</h4>
            <p>Reembolso si no estás satisfecho</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Instructores destacados -->
    <div class="instructors-section">
      <div class="container">
        <div class="section-title">
          <h2>👨‍🏫 Instructores destacados</h2>
          <p>Aprende de los mejores profesionales</p>
        </div>
        <div class="instructors-grid">
          <div
            v-for="instructor in instructores"
            :key="instructor.nombre"
            class="instructor-card"
          >
            <div class="instructor-avatar">{{ instructor.avatar }}</div>
            <h4>{{ instructor.nombre }}</h4>
            <p>{{ instructor.especialidad }}</p>
            <div class="instructor-rating">
              ⭐ {{ instructor.rating }} ({{ instructor.cursos }} cursos)
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Testimonios -->
    <div class="testimonials-section">
      <div class="container">
        <div class="section-title">
          <h2>💬 Lo que dicen nuestros estudiantes</h2>
        </div>
        <div class="testimonials-grid">
          <div v-for="test in testimonios" :key="test.nombre" class="testimonial-card">
            <div class="testimonial-text">"{{ test.texto }}"</div>
            <div class="testimonial-author">
              <div class="author-avatar">{{ test.avatar }}</div>
              <div>
                <h4>{{ test.nombre }}</h4>
                <p>{{ test.curso }}</p>
                <span>⭐ {{ test.rating }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Newsletter -->
    <div class="newsletter-section">
      <div class="container">
        <div class="newsletter-content">
          <h3>📧 ¡No te pierdas las novedades!</h3>
          <p>Recibe información sobre nuevos cursos y promociones</p>
          <div class="newsletter-form">
            <input
              type="email"
              v-model="newsletterEmail"
              placeholder="Tu correo electrónico"
            />
            <button @click="suscribirNewsletter">Suscribirme</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer">
      <div class="container">
        <div class="footer-grid">
          <div>
            <h4>AcademiaOnline</h4>
            <p>Transformando la educación digital</p>
          </div>
          <div>
            <h4>Enlaces</h4>
            <a href="#">Términos y condiciones</a>
            <a href="#">Política de privacidad</a>
            <a href="#">Preguntas frecuentes</a>
          </div>
          <div>
            <h4>Contacto</h4>
            <p>📞 +51 928 180 748</p>
            <p>✉️ info@academiaonline.com</p>
            <p>💬 WhatsApp: +51 987 654 321</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2024 AcademiaOnline - Todos los derechos reservados</p>
        </div>
      </div>
    </div>

    <!-- ========== CARRITO FLOTANTE ========== -->
    <div class="cart-floating" @click="verCarrito">
      <div class="cart-icon">
        🛒
        <span class="cart-badge">{{ carrito.length }}</span>
      </div>
      <div class="cart-total">S/ {{ totalCarrito }}</div>
    </div>

    <!-- Modal carrito -->
    <div v-if="mostrarCarrito" class="modal-overlay" @click.self="cerrarCarrito">
      <div class="modal-container">
        <div class="modal-header">
          <h3>🛒 Mi carrito ({{ carrito.length }})</h3>
          <button class="modal-close" @click="cerrarCarrito">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="carrito.length === 0" class="empty-cart">
            <div>📚</div>
            <p>Tu carrito está vacío</p>
            <button @click="cerrarCarrito">Explorar cursos</button>
          </div>
          <div v-else>
            <div v-for="(item, idx) in carrito" :key="item.id" class="cart-item">
              <div class="cart-info">
                <div class="cart-name">{{ item.nombre }}</div>
                <div class="cart-price">S/ {{ item.precio }}</div>
              </div>
              <div class="cart-actions">
                <button @click="disminuirCantidad(idx)">-</button>
                <span>{{ item.cantidad }}</span>
                <button @click="aumentarCantidad(idx)">+</button>
                <button class="remove-btn" @click="eliminarDelCarrito(idx)">🗑️</button>
              </div>
            </div>
            <div class="cart-total-row">
              <span>Total:</span>
              <strong>S/ {{ totalCarrito }}</strong>
            </div>
            <button class="checkout-btn" @click="irAPagar">Proceder al pago →</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pago -->
    <div v-if="mostrarPago" class="modal-overlay" @click.self="cerrarPago">
      <div class="modal-container modal-pago">
        <div class="modal-header">
          <h3>💳 Finalizar compra</h3>
          <button class="modal-close" @click="cerrarPago">✕</button>
        </div>
        <div class="modal-body">
          <div class="order-summary">
            <div v-for="item in carrito" :key="item.id" class="order-item">
              <span>{{ item.nombre }} x {{ item.cantidad }}</span>
              <span>S/ {{ item.precio * item.cantidad }}</span>
            </div>
            <div class="order-total">Total: S/ {{ totalCarrito }}</div>
          </div>
          <input
            type="text"
            v-model="compra.nombre"
            placeholder="Nombre completo"
            class="input-field"
          />
          <input
            type="email"
            v-model="compra.email"
            placeholder="Correo electrónico"
            class="input-field"
          />
          <input
            type="text"
            v-model="compra.telefono"
            placeholder="Teléfono"
            class="input-field"
          />
          <div class="payment-methods">
            <label
              ><input type="radio" value="tarjeta" v-model="compra.pago" /> 💳 Tarjeta de
              crédito/débito</label
            >
            <label
              ><input type="radio" value="yape" v-model="compra.pago" /> 📱 Yape</label
            >
            <label
              ><input type="radio" value="plin" v-model="compra.pago" /> 📱 Plin</label
            >
          </div>
          <button class="pay-btn" @click="confirmarCompra">Confirmar compra</button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div v-if="toastVisible" class="toast">
      {{ toastMensaje }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AcademiaOnline",
  data() {
    return {
      searchTerm: "",
      filtroActivo: "Todos",
      filtros: ["Todos", "Programación", "Marketing", "Diseño", "Negocios", "Idiomas"],
      mostrarCarrito: false,
      mostrarPago: false,
      toastVisible: false,
      toastMensaje: "",
      newsletterEmail: "",
      carrito: [],
      compra: { nombre: "", email: "", telefono: "", pago: "tarjeta" },
      categorias: [
        { nombre: "Programación", icono: "💻", cantidad: 45 },
        { nombre: "Marketing", icono: "📈", cantidad: 32 },
        { nombre: "Diseño", icono: "🎨", cantidad: 28 },
        { nombre: "Negocios", icono: "💼", cantidad: 24 },
        { nombre: "Idiomas", icono: "🌎", cantidad: 38 },
        { nombre: "Data Science", icono: "📊", cantidad: 18 },
      ],
      cursos: [
        {
          id: 1,
          nombre: "Desarrollo Web Full Stack",
          tipo: "Programación",
          icono: "💻",
          descripcion: "HTML, CSS, JavaScript, Vue.js, Node.js",
          instructor: "Carlos Mendoza",
          duracion: "8 semanas",
          clases: 64,
          rating: 4.9,
          reviews: 1245,
          precio: 299,
          precio_anterior: 499,
          oferta: true,
          descuento: 40,
        },
        {
          id: 2,
          nombre: "Marketing Digital Avanzado",
          tipo: "Marketing",
          icono: "📈",
          descripcion: "SEO, SEM, Redes Sociales, Analytics",
          instructor: "María Rodríguez",
          duracion: "6 semanas",
          clases: 48,
          rating: 4.8,
          reviews: 987,
          precio: 249,
          precio_anterior: 399,
          oferta: true,
          descuento: 38,
        },
        {
          id: 3,
          nombre: "Diseño UX/UI",
          tipo: "Diseño",
          icono: "🎨",
          descripcion: "Figma, Adobe XD, prototipado",
          instructor: "Ana López",
          duracion: "6 semanas",
          clases: 52,
          rating: 4.7,
          reviews: 756,
          precio: 279,
          precio_anterior: 449,
          oferta: true,
          descuento: 38,
        },
        {
          id: 4,
          nombre: "Python para Data Science",
          tipo: "Programación",
          icono: "🐍",
          descripcion: "Pandas, NumPy, Matplotlib, Machine Learning",
          instructor: "Javier Torres",
          duracion: "10 semanas",
          clases: 80,
          rating: 4.9,
          reviews: 1567,
          precio: 329,
          precio_anterior: 549,
          oferta: true,
          descuento: 40,
        },
        {
          id: 5,
          nombre: "Inglés Profesional",
          tipo: "Idiomas",
          icono: "🌎",
          descripcion: "Inglés técnico y conversacional",
          instructor: "Laura Sánchez",
          duracion: "12 semanas",
          clases: 96,
          rating: 4.6,
          reviews: 543,
          precio: 199,
          precio_anterior: 349,
          oferta: false,
        },
        {
          id: 6,
          nombre: "Gestión de Proyectos",
          tipo: "Negocios",
          icono: "📋",
          descripcion: "Scrum, Kanban, certificación PMP",
          instructor: "Roberto Díaz",
          duracion: "8 semanas",
          clases: 56,
          rating: 4.8,
          reviews: 876,
          precio: 259,
          precio_anterior: 429,
          oferta: true,
          descuento: 40,
        },
        {
          id: 7,
          nombre: "Fotografía Digital",
          tipo: "Diseño",
          icono: "📷",
          descripcion: "Composición, Lightroom, Photoshop",
          instructor: "Patricia Gómez",
          duracion: "5 semanas",
          clases: 40,
          rating: 4.7,
          reviews: 654,
          precio: 189,
          precio_anterior: 299,
          oferta: false,
        },
        {
          id: 8,
          nombre: "Excel Avanzado",
          tipo: "Negocios",
          icono: "📊",
          descripcion: "Tablas dinámicas, macros, VBA",
          instructor: "Luis Fernández",
          duracion: "4 semanas",
          clases: 32,
          rating: 4.8,
          reviews: 1234,
          precio: 159,
          precio_anterior: 279,
          oferta: true,
          descuento: 43,
        },
      ],
      instructores: [
        {
          nombre: "Carlos Mendoza",
          especialidad: "Desarrollo Web",
          avatar: "👨‍💻",
          rating: 4.9,
          cursos: 12,
        },
        {
          nombre: "María Rodríguez",
          especialidad: "Marketing Digital",
          avatar: "👩‍💻",
          rating: 4.8,
          cursos: 8,
        },
        {
          nombre: "Ana López",
          especialidad: "Diseño UX/UI",
          avatar: "👩‍🎨",
          rating: 4.7,
          cursos: 6,
        },
        {
          nombre: "Javier Torres",
          especialidad: "Data Science",
          avatar: "👨‍🔬",
          rating: 4.9,
          cursos: 5,
        },
      ],
      testimonios: [
        {
          nombre: "Carlos Pérez",
          texto: "Excelente plataforma, los cursos son muy completos",
          curso: "Desarrollo Web",
          avatar: "👨",
          rating: 5,
        },
        {
          nombre: "Valentina Ramírez",
          texto: "Gracias a este curso conseguí un nuevo trabajo",
          curso: "Marketing Digital",
          avatar: "👩",
          rating: 5,
        },
        {
          nombre: "Andrés López",
          texto: "Metodología práctica y excelente soporte",
          curso: "Python",
          avatar: "👨",
          rating: 5,
        },
      ],
    };
  },
  computed: {
    cursosFiltrados() {
      let filtrados = this.cursos;
      if (this.filtroActivo !== "Todos") {
        filtrados = filtrados.filter((c) => c.tipo === this.filtroActivo);
      }
      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        filtrados = filtrados.filter(
          (c) =>
            c.nombre.toLowerCase().includes(term) ||
            c.descripcion.toLowerCase().includes(term)
        );
      }
      return filtrados;
    },
    totalCarrito() {
      return this.carrito.reduce((t, i) => t + i.precio * i.cantidad, 0);
    },
  },
  methods: {
    goBack() {
      window.location.href = "/portafolio";
    },
    scrollToCursos() {
      document.getElementById("cursos").scrollIntoView({ behavior: "smooth" });
    },
    buscarCursos() {
      if (this.searchTerm) this.scrollToCursos();
    },
    limpiarBusqueda() {
      this.searchTerm = "";
      this.filtroActivo = "Todos";
    },
    filtrarPorCategoria(cat) {
      this.filtroActivo = cat;
      this.scrollToCursos();
    },
    agregarAlCarrito(curso) {
      const exist = this.carrito.find((i) => i.id === curso.id);
      if (exist) exist.cantidad++;
      else this.carrito.push({ ...curso, cantidad: 1 });
      this.showToast(`📚 ${curso.nombre} agregado al carrito`);
    },
    aumentarCantidad(i) {
      this.carrito[i].cantidad++;
    },
    disminuirCantidad(i) {
      if (this.carrito[i].cantidad > 1) this.carrito[i].cantidad--;
      else this.eliminarDelCarrito(i);
    },
    eliminarDelCarrito(i) {
      this.carrito.splice(i, 1);
      this.showToast("🗑️ Curso eliminado");
    },
    verCarrito() {
      this.mostrarCarrito = true;
    },
    cerrarCarrito() {
      this.mostrarCarrito = false;
    },
    irAPagar() {
      this.mostrarCarrito = false;
      this.mostrarPago = true;
    },
    cerrarPago() {
      this.mostrarPago = false;
    },
    confirmarCompra() {
      if (!this.compra.nombre || !this.compra.email) {
        this.showToast("⚠️ Completa tus datos");
        return;
      }
      this.showToast(
        `🎓 ¡Gracias ${this.compra.nombre}! Acceso a los cursos enviado a tu correo`
      );
      setTimeout(() => {
        this.carrito = [];
        this.mostrarPago = false;
        this.compra = { nombre: "", email: "", telefono: "", pago: "tarjeta" };
      }, 2500);
    },
    suscribirNewsletter() {
      if (this.newsletterEmail) {
        this.showToast("📧 ¡Suscripción exitosa! Recibirás nuestras novedades");
        this.newsletterEmail = "";
      }
    },
    showToast(msg) {
      this.toastMensaje = msg;
      this.toastVisible = true;
      setTimeout(() => {
        this.toastVisible = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.academia-online {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  background: #f0f4f8;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Top bar */
.top-bar {
  background: #1a3a5c;
  color: white;
  padding: 8px 0;
  font-size: 13px;
}
.top-links {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
}

/* Header */
.main-header {
  background: white;
  padding: 15px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.logo-icon {
  font-size: 32px;
}
.logo-text {
  font-size: 24px;
  font-weight: bold;
}
.logo-blue {
  color: #1a73e8;
}
.search-wrapper {
  flex: 1;
  max-width: 500px;
}
.search-box {
  display: flex;
  border: 2px solid #1a73e8;
  border-radius: 8px;
  overflow: hidden;
}
.search-input {
  flex: 1;
  padding: 12px 16px;
  border: none;
  outline: none;
}
.search-btn {
  background: #1a73e8;
  color: white;
  border: none;
  padding: 12px 24px;
  cursor: pointer;
}
.cart-floating-small {
  background: #1a73e8;
  border-radius: 30px;
  padding: 8px 16px;
  display: flex;
  gap: 8px;
  cursor: pointer;
  color: white;
}
.cart-count-small {
  background: white;
  color: #1a73e8;
  border-radius: 50%;
  padding: 0 6px;
  font-size: 12px;
}

/* Hero */
.hero-banner {
  background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
  padding: 60px 0;
}
.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hero-text h1 {
  font-size: 48px;
  color: white;
  margin-bottom: 15px;
}
.hero-text p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 25px;
}
.hero-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.stat {
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 16px;
  border-radius: 30px;
  color: white;
  font-size: 14px;
}
.hero-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}
.btn-primary {
  background: white;
  color: #1a73e8;
  border: none;
  padding: 12px 28px;
  border-radius: 30px;
  font-weight: bold;
  cursor: pointer;
}
.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 12px 28px;
  border-radius: 30px;
  cursor: pointer;
}
.hero-image {
  font-size: 80px;
}

/* Promo */
.promo-banner {
  background: #ffc107;
  padding: 12px 0;
  text-align: center;
  font-weight: bold;
}
.promo-content {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}
.promo-code {
  background: #1a73e8;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
}

/* Categories */
.categories-section {
  padding: 50px 0;
  background: white;
}
.section-title {
  text-align: center;
  margin-bottom: 40px;
}
.section-title h2 {
  font-size: 32px;
  color: #1a3a5c;
  margin-bottom: 10px;
}
.section-title p {
  color: #666;
}
.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}
.cat-card {
  text-align: center;
  padding: 25px;
  background: #f8fafc;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #e0e7ef;
}
.cat-card:hover {
  transform: translateY(-5px);
  border-color: #1a73e8;
}
.cat-icon {
  font-size: 40px;
  margin-bottom: 10px;
}
.cat-card h3 {
  font-size: 16px;
  margin-bottom: 5px;
}
.cat-card p {
  font-size: 12px;
  color: #999;
}

/* Courses */
.courses-section {
  padding: 50px 0;
  background: #f0f4f8;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
}
.filters {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filters button {
  background: white;
  border: 1px solid #ddd;
  padding: 8px 20px;
  border-radius: 30px;
  cursor: pointer;
}
.filters button.active {
  background: #1a73e8;
  color: white;
  border-color: #1a73e8;
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 25px;
}
.course-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}
.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}
.course-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #e74c3c;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
}
.course-img {
  background: #1a3a5c;
  text-align: center;
  padding: 30px;
  font-size: 50px;
}
.course-info {
  padding: 20px;
}
.course-info h3 {
  font-size: 18px;
  margin-bottom: 8px;
  color: #1a3a5c;
}
.course-desc {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
}
.course-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  font-size: 12px;
  color: #888;
}
.course-rating {
  color: #ffc107;
  margin-bottom: 12px;
  font-size: 13px;
}
.course-price {
  margin-bottom: 15px;
}
.current {
  font-size: 22px;
  font-weight: bold;
  color: #1a73e8;
}
.old {
  font-size: 14px;
  text-decoration: line-through;
  color: #999;
  margin-left: 8px;
}
.add-btn {
  width: 100%;
  background: #1a73e8;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
}

/* Benefits */
.benefits-section {
  padding: 50px 0;
  background: white;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 25px;
}
.benefit {
  text-align: center;
  padding: 20px;
}
.benefit div {
  font-size: 40px;
  margin-bottom: 12px;
}
.benefit h4 {
  margin-bottom: 8px;
  color: #1a3a5c;
}
.benefit p {
  font-size: 12px;
  color: #666;
}

/* Instructors */
.instructors-section {
  padding: 50px 0;
  background: #f0f4f8;
}
.instructors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 25px;
}
.instructor-card {
  text-align: center;
  padding: 25px;
  background: white;
  border-radius: 16px;
}
.instructor-avatar {
  font-size: 48px;
  margin-bottom: 10px;
}
.instructor-card h4 {
  margin-bottom: 5px;
}
.instructor-card p {
  font-size: 12px;
  color: #1a73e8;
  margin-bottom: 8px;
}
.instructor-rating {
  font-size: 12px;
  color: #ffc107;
}

/* Testimonials */
.testimonials-section {
  padding: 50px 0;
  background: white;
}
.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
}
.testimonial-card {
  padding: 25px;
  background: #f8fafc;
  border-radius: 16px;
}
.testimonial-text {
  font-size: 14px;
  color: #555;
  line-height: 1.5;
  margin-bottom: 15px;
  font-style: italic;
}
.testimonial-author {
  display: flex;
  align-items: center;
  gap: 12px;
}
.author-avatar {
  font-size: 40px;
}

/* Newsletter */
.newsletter-section {
  padding: 50px 0;
  background: #1a73e8;
  color: white;
}
.newsletter-content {
  text-align: center;
}
.newsletter-content h3 {
  font-size: 24px;
  margin-bottom: 10px;
}
.newsletter-form {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  flex-wrap: wrap;
}
.newsletter-form input {
  padding: 12px 20px;
  border: none;
  border-radius: 30px;
  width: 280px;
}
.newsletter-form button {
  background: #ffc107;
  color: #1a3a5c;
  border: none;
  padding: 12px 28px;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
}

/* Footer */
.footer {
  background: #1a3a5c;
  color: #ccc;
  padding: 40px 0 20px;
}
.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-bottom: 30px;
}
.footer-grid h4 {
  color: white;
  margin-bottom: 15px;
}
.footer-grid a {
  display: block;
  color: #ccc;
  text-decoration: none;
  font-size: 13px;
  margin-bottom: 8px;
}
.footer-grid a:hover {
  color: #ffc107;
}
.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #2a4a6c;
  font-size: 12px;
}

/* Cart floating */
.cart-floating {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #1a73e8;
  border-radius: 50px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}
.cart-icon {
  font-size: 24px;
  position: relative;
}
.cart-badge {
  position: absolute;
  top: -10px;
  right: -12px;
  background: #e74c3c;
  color: white;
  border-radius: 50%;
  padding: 2px 7px;
  font-size: 11px;
}
.cart-total {
  background: white;
  color: #1a73e8;
  padding: 5px 12px;
  border-radius: 30px;
  font-weight: bold;
}

/* Modales */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-container {
  background: white;
  border-radius: 20px;
  max-width: 550px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #eee;
}
.modal-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}
.modal-body {
  padding: 22px;
}
.empty-cart {
  text-align: center;
  padding: 40px;
}
.empty-cart div {
  font-size: 60px;
  margin-bottom: 15px;
}
.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
  gap: 10px;
}
.cart-name {
  font-weight: bold;
  font-size: 14px;
}
.cart-price {
  font-size: 12px;
  color: #1a73e8;
}
.cart-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cart-actions button {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
}
.remove-btn {
  background: none !important;
  border: none !important;
}
.cart-total-row {
  text-align: right;
  padding: 15px 0;
  font-size: 18px;
  border-top: 2px solid #eee;
  margin-top: 10px;
}
.checkout-btn,
.pay-btn {
  width: 100%;
  background: #1a73e8;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 15px;
}
.order-summary {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 12px;
  margin-bottom: 20px;
}
.order-item {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
}
.order-total {
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #ddd;
  font-weight: bold;
}
.input-field {
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #ddd;
  border-radius: 10px;
}
.payment-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 15px 0;
}
.payment-methods label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.toast {
  position: fixed;
  bottom: 100px;
  right: 30px;
  background: #28a745;
  color: white;
  padding: 12px 20px;
  border-radius: 30px;
  z-index: 1001;
  animation: slideIn 0.3s ease;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 768px) {
  .hero-text h1 {
    font-size: 28px;
  }
  .hero-image {
    display: none;
  }
  .header-row {
    flex-direction: column;
  }
  .search-wrapper {
    max-width: 100%;
    width: 100%;
  }
  .courses-grid {
    grid-template-columns: 1fr;
  }
}
</style>
